export class AppError {
  public message?: string

  constructor(errorMessage?: string) {
    this.message = errorMessage
  }

  public toString() {
    return this.message
  }
}

export class UserInputError extends AppError {}
